import { defineMessages } from 'react-intl-next';

export default defineMessages({
	fileCloseIconLabel: {
		id: 'ai-mate.chat-input.file-close-icon-label',
		defaultMessage: 'Remove file',
		description: 'Label for the remove file icon',
	},
	fileErrorIconLabel: {
		id: 'ai-mate.chat-input.file-error-icon-label',
		defaultMessage: 'Error loading file',
		description: 'Label for the error icon',
	},
	textLoadFailed: {
		id: 'ai-mate.chat-input.text-load-failed',
		defaultMessage: 'Failed to load file content',
		description: 'Fallback message shown when reading a text file fails',
	},
} as const);
